(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const source = document.getElementById(root.dataset.sourceButtonId || '');
    const trigger = root.querySelector('[data-dt-floating-trigger]');
    const dialog = root.querySelector('[data-dt-floating-dialog]');
    const optionsSlot = root.querySelector('[data-dt-floating-options]');
    const closeButton = root.querySelector('[data-dt-floating-close]');
    const submitButton = root.querySelector('[data-dt-floating-submit]');
    const triggerPrice = root.querySelector('[data-dt-floating-trigger-price]');
    const totalPrice = root.querySelector('[data-dt-floating-total]');
    const totalWrap = root.querySelector('[data-dt-floating-total-wrap]');
    if (!source || !trigger || !dialog || !submitButton) return;

    const scope = root.closest('[data-dtv2-root], .dt-product-template, .shopify-section') || document;

    // Product sections can establish their own containing or clipping context.
    // Keep a reference to the original scope for option discovery, then mount
    // the fixed purchase UI directly under body so it is fixed to the viewport.
    if (root.parentNode !== document.body) document.body.appendChild(root);
    let movedOptions = [];
    let copyMode = '';
    let ticking = false;

    const endBoundary = Array.from(document.querySelectorAll('main .shopify-section')).find(
      (section) =>
        section.id.includes('related-products') &&
        Boolean(source.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING)
    ) || document.querySelector('footer');

    const currentPriceText = () => {
      const candidates = Array.from(
        scope.querySelectorAll(
          '[data-dt-v2-total-price], .price__container .price-item--sale.price-item--last, .price__container .price-item--regular'
        )
      );
      const visible = candidates.find((node) => node.getClientRects().length && node.textContent.trim());
      return (visible || candidates.find((node) => node.textContent.trim()))?.textContent?.trim() || '';
    };

    const syncPrice = () => {
      const price = currentPriceText();
      if (triggerPrice) {
        triggerPrice.textContent = price;
        triggerPrice.hidden = !price;
      }
      if (totalPrice) totalPrice.textContent = price;
      if (totalWrap) totalWrap.hidden = !price;
    };

    const dtv2Selectors = () =>
      Array.from(scope.querySelectorAll('[data-dtv2-selector]')).filter((node) => !dialog.contains(node));

    const optionNodes = () => {
      const dtv2 = dtv2Selectors();
      if (dtv2.length) return dtv2;
      return Array.from(scope.querySelectorAll('variant-selects, variant-radios')).filter((node) => !dialog.contains(node));
    };

    const optionText = (label, selector) =>
      label.querySelector(selector)?.textContent?.trim() || '';

    const syncDtv2Copies = () => {
      if (copyMode !== 'dtv2' || !optionsSlot) return;
      optionsSlot.querySelectorAll('[data-dt-floating-choice]').forEach((button) => {
        const input = document.getElementById(button.dataset.inputId || '');
        const originalLabel = input?.closest('label');
        const active = input?.checked === true;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = input?.disabled === true;
        const price = button.querySelector('[data-dt-floating-choice-price]');
        if (price && originalLabel) {
          price.textContent = optionText(originalLabel, '.dtv2-style-option__price, .dt-v2-case-option__price');
        }
      });
    };

    const buildDtv2Copies = (selectors) => {
      if (!optionsSlot) return;
      optionsSlot.replaceChildren();
      copyMode = 'dtv2';

      selectors.forEach((selector) => {
        const group = document.createElement('section');
        group.className = 'dt-floating-purchase__choice-group';

        const heading = document.createElement('p');
        heading.className = 'dt-floating-purchase__choice-heading';
        heading.textContent = selector.querySelector('.dtv2-selector__label')?.textContent?.trim() || '';
        const groupType = /^style$/i.test(heading.textContent)
          ? 'style'
          : /^case$/i.test(heading.textContent)
            ? 'case'
            : '';
        if (groupType) group.classList.add(`dt-floating-purchase__choice-group--${groupType}`);
        group.appendChild(heading);

        const list = document.createElement('div');
        list.className = 'dt-floating-purchase__choice-list';

        selector.querySelectorAll('input[type="radio"]').forEach((input) => {
          const originalLabel = input.closest('label');
          if (!originalLabel || !input.id) return;

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dt-floating-purchase__choice';
          button.dataset.dtFloatingChoice = '';
          button.dataset.inputId = input.id;

          const copy = document.createElement('span');
          copy.className = 'dt-floating-purchase__choice-copy';
          const name = document.createElement('strong');
          name.textContent = optionText(originalLabel, '.dtv2-style-option__name, .dt-v2-case-option__title');
          const detail = document.createElement('small');
          detail.textContent = optionText(originalLabel, '.dtv2-style-option__detail, .dt-v2-case-option__description');
          copy.appendChild(name);
          if (groupType !== 'case' && detail.textContent) copy.appendChild(detail);

          const price = document.createElement('span');
          price.className = 'dt-floating-purchase__choice-price';
          price.dataset.dtFloatingChoicePrice = '';
          price.textContent = optionText(originalLabel, '.dtv2-style-option__price, .dt-v2-case-option__price');
          button.append(copy, price);

          button.addEventListener('click', () => {
            if (input.disabled) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            window.setTimeout(() => {
              syncDtv2Copies();
              syncPrice();
            }, 0);
          });
          list.appendChild(button);
        });

        group.appendChild(list);
        optionsSlot.appendChild(group);
      });
      syncDtv2Copies();
    };

    const syncStandardCopies = () => {
      if (copyMode !== 'standard' || !optionsSlot) return;
      optionsSlot.querySelectorAll('[data-dt-floating-choice]').forEach((button) => {
        const input = document.getElementById(button.dataset.inputId || '');
        const active = input?.checked === true;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = input?.disabled === true;
      });
    };

    const buildStandardCopies = (selectors) => {
      if (!optionsSlot) return;
      optionsSlot.replaceChildren();
      copyMode = 'standard';

      selectors.forEach((selector) => {
        selector.querySelectorAll('.product-form__input').forEach((fieldset) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          if (!inputs.length) return;

          const group = document.createElement('section');
          group.className = 'dt-floating-purchase__choice-group';

          const heading = document.createElement('p');
          heading.className = 'dt-floating-purchase__choice-heading';
          heading.textContent = fieldset.querySelector('.form__label')?.textContent?.trim() || '';
          if (heading.textContent) group.appendChild(heading);

          const list = document.createElement('div');
          list.className = 'dt-floating-purchase__choice-list';

          inputs.forEach((input) => {
            const originalLabel = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`) || input.nextElementSibling;
            if (!originalLabel || !input.id) return;

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'dt-floating-purchase__choice';
            button.dataset.dtFloatingChoice = '';
            button.dataset.inputId = input.id;

            const copy = document.createElement('span');
            copy.className = 'dt-floating-purchase__choice-copy';
            const name = document.createElement('strong');
            name.textContent = input.value || originalLabel.childNodes[0]?.textContent?.trim() || '';
            copy.appendChild(name);
            button.appendChild(copy);

            button.addEventListener('click', () => {
              const currentInput = document.getElementById(button.dataset.inputId || '');
              if (!currentInput || currentInput.disabled) return;
              const mediaGallery = scope.querySelector('media-gallery');
              if (mediaGallery) {
                mediaGallery.dataset.dtPreventPageScroll = 'true';
                window.setTimeout(() => delete mediaGallery.dataset.dtPreventPageScroll, 2000);
              }
              currentInput.checked = true;
              currentInput.dispatchEvent(new Event('change', { bubbles: true }));
              window.setTimeout(() => {
                syncStandardCopies();
                syncPrice();
              }, 0);
            });
            list.appendChild(button);
          });

          group.appendChild(list);
          optionsSlot.appendChild(group);
        });
      });
      syncStandardCopies();
    };

    const syncCopiedOptions = () => {
      if (copyMode === 'dtv2') syncDtv2Copies();
      if (copyMode === 'standard') syncStandardCopies();
    };

    const moveOptionsIntoDialog = () => {
      if (!optionsSlot || movedOptions.length) return;
      const dtv2 = dtv2Selectors();
      if (dtv2.length) {
        buildDtv2Copies(dtv2);
        return;
      }
      buildStandardCopies(optionNodes());
    };

    const restoreOptions = () => {
      movedOptions.forEach(({ node, marker }) => {
        marker.parentNode?.insertBefore(node, marker);
        marker.remove();
      });
      movedOptions = [];
      if (copyMode) optionsSlot?.replaceChildren();
      copyMode = '';
    };

    const syncDisabled = () => {
      const disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      trigger.disabled = disabled;
      submitButton.disabled = disabled;
      const sourceLabel = source.querySelector('span')?.textContent?.trim();
      if (disabled && sourceLabel) trigger.querySelector('span').textContent = sourceLabel;
    };

    const updateVisibility = () => {
      ticking = false;
      if (dialog.open === true || dialog.hasAttribute('open')) {
        root.hidden = false;
        return;
      }
      const header = document.querySelector('.shopify-section-group-header-group');
      const headerBottom = Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
      const sourceRect = source.getBoundingClientRect();
      const passedPurchaseButton = sourceRect.bottom < headerBottom + 8;
      const beforeRelatedProducts = !endBoundary || endBoundary.getBoundingClientRect().top > window.innerHeight;
      root.hidden = !(passedPurchaseButton && beforeRelatedProducts);
    };

    const requestVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateVisibility);
    };

    const dialogIsOpen = () => dialog.open === true || dialog.hasAttribute('open');

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
        return;
      }
      dialog.removeAttribute('open');
      restoreOptions();
      updateVisibility();
    };

    trigger.addEventListener('click', () => {
      if (root.dataset.hasOptions === 'true' && optionNodes().length) {
        moveOptionsIntoDialog();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        dialog.focus?.({ preventScroll: true });
        updateVisibility();
        return;
      }
      source.click();
    });

    submitButton.addEventListener('click', () => {
      closeDialog();
      requestAnimationFrame(() => source.click());
    });
    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('close', () => {
      restoreOptions();
      updateVisibility();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dialogIsOpen()) closeDialog();
    });

    new MutationObserver(syncDisabled).observe(source, { attributes: true, childList: true, subtree: true });
    new MutationObserver(syncPrice).observe(scope, { childList: true, subtree: true, characterData: true });
    scope.addEventListener('change', () => window.setTimeout(() => {
      syncCopiedOptions();
      syncPrice();
    }, 0));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(requestVisibilityUpdate, { threshold: [0, 1] }).observe(source);
      if (endBoundary) new IntersectionObserver(requestVisibilityUpdate, { threshold: [0, 1] }).observe(endBoundary);
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(requestVisibilityUpdate).observe(document.documentElement);
    }
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    window.addEventListener('load', requestVisibilityUpdate, { once: true });
    syncDisabled();
    syncPrice();
    updateVisibility();
    window.setTimeout(requestVisibilityUpdate, 500);
    window.setTimeout(requestVisibilityUpdate, 1400);
  };

  const initializeAll = () => document.querySelectorAll('[data-dt-floating-purchase]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
})();
